import React, { Fragment, useEffect, useState } from "react";
import log from "cslog";
import {
    Button,
    Checkbox,
    Col,
    Form,
    Input,
    Popover,
    Space,
    Row,
    Segmented,
    Select,
    Alert,
} from "antd";
import OrgPicker from "./OrgPicker";
import RelationFieldStanard from "../../qforms/standard_elements/RelationFieldStandard";
import {
    BulbOutlined,
    CloseOutlined,
    ControlOutlined,
    EditOutlined,
    UploadOutlined,
} from "@ant-design/icons";
import startCase from "lodash/startCase";
import { UserInputFormOne } from "./UserInputForm";
import { useFieldsDirect, useQdbFields } from "../../_actions/app/fields";
import {
    useItemsFine,
    useUpdateItemMutation,
    useUpdateItemsMutation,
} from "../../_actions/app/items";
import AIModelPicker from "./AIModelPicker";
import PresetHumanInput from "./PresetHumanInput";
import styles from "./styles/TemplateAIInput.module.css";
import { getPublicImageURL } from "../../_helpers/image";
import ProductSelector from "../../qbuilt_settings/brands/org/ProductSelector";
import PhotoButton from "../../qforms/standard_elements/PhotoButton";
import BulkGeneration from "../../bulk/BulkGeneration";
import { getHeroIcon } from "../../_helpers/heroicons";
import TokenInButton from "../../finance/TokenInButton";
import { COST_PROCESS_IDEA } from "../../constants";

const { TextArea } = Input;

function TemplateAIInput({
    record_id,
    inputs = [],
    used_schemas = [],
    user_inputs = {},
    me,
    creation_type,
    org,
    lang,
    onOrgChange,
    person,
    onPersonChange,
    isMobile,
    loadingAI,
    prefill,
    setPrefill,

    onSubmitInputs,
    slug = null,
    is_template,
    linkedPresetData,
}) {
    const [schemas, setSchemas] = useState({});

    useEffect(() => {
        if (used_schemas.length > 0) {
            const out = {};

            used_schemas.forEach((schema) => {
                if (
                    linkedPresetData?.origin_preset?.id ===
                    schema?.qdb_creation_schema_id?.id
                ) {
                    out[linkedPresetData?.id] = linkedPresetData;
                } else {
                    out[schema.qdb_creation_schema_id?.id] =
                        schema.qdb_creation_schema_id;
                }
            });
            setSchemas(out);
        }
    }, [used_schemas]);

    const page_id = creation_type === "document" ? "home" : "frontSide";

    const pageInputs = inputs?.[page_id];

    log.d(schemas, "Schemas in PreviewTemplate");

    if (!pageInputs) {
        return <></>;
    }
    return (
        <div>
            {/* <h4>Customize</h4> */}

            {/* <pre>{JSON.stringify(pageInputs, null, 2)}</pre> */}
            {Object.values(pageInputs).filter(
                (input) => input.block_type === "qureal_preset",
            ).length === 0 && (
                <Alert message="This is a static design" type="info" />
            )}
            <p>
                {Object.keys(pageInputs).map((input_id) => {
                    const input = pageInputs[input_id];
                    log.d(input, "input in TemplateAIInput");
                    switch (input.block_type) {
                        case "qureal_database":
                            if (input_id === "current_organization") {
                                return <></>;
                            }
                            return (
                                <DBInput
                                    record_id={record_id}
                                    input_id={input_id}
                                    input_data={input?.data}
                                    me={me}
                                    isMobile={isMobile}
                                    org={org}
                                    onOrgChange={onOrgChange}
                                    person={person}
                                    onPersonChange={onPersonChange}
                                    prefill={prefill?.[input_id]}
                                    setPrefill={(new_values) => {
                                        setPrefill({
                                            ...prefill,
                                            [input_id]: new_values || {},
                                        });
                                    }}
                                />
                            );
                        case "qureal_preset":
                            return (
                                <>
                                    <PresetInput
                                        me={me}
                                        input_data={input?.data}
                                        schemas={schemas}
                                        loadingAI={loadingAI}
                                        user_inputs={
                                            user_inputs?.enable
                                                ? user_inputs?.data?.[input_id]
                                                : {}
                                        }
                                        data_block_id={input_id}
                                        prefill={prefill[input_id]}
                                        setPrefill={(new_values) => {
                                            setPrefill({
                                                ...prefill,
                                                [input_id]: new_values || {},
                                            });
                                        }}
                                        onSubmitInputs={(new_values) => {
                                            onSubmitInputs({
                                                block_id: input_id,
                                                preset_id:
                                                    input?.data
                                                        ?.qureal_schema_id,
                                                lang: lang,
                                                user_inputs: new_values,
                                                extra: input?.data?.extra
                                                    ? normalizeExtra(
                                                          input.data.extra,
                                                      )
                                                    : {},
                                                post_context:
                                                    input?.data
                                                        ?.preset_context || "",
                                                template_id: is_template
                                                    ? record_id
                                                    : null,

                                                // input: input
                                            });
                                        }}
                                        slug={slug}
                                        is_template={is_template}
                                    />
                                </>
                            );
                        case "ai_model":
                            return (
                                <div className={styles.chat_box_wrapper}>
                                    <AIModelPicker
                                        input_id={input_id}
                                        input_data={input?.data}
                                        onChange={(new_values) => {
                                            // alert(`New model: ${JSON.stringify(new_values)}`)
                                            setPrefill({
                                                ...prefill,
                                                [input_id]: new_values,
                                            });
                                        }}
                                    />
                                </div>
                            );
                        default:
                            return (
                                <p className="q_gray">
                                    {input?.block_type} not supported yet.
                                </p>
                            );
                    }
                })}
            </p>
        </div>
    );
}

export default TemplateAIInput;

function PresetInput({
    input_data,
    schemas,
    user_inputs,
    loadingAI,
    data_block_id,
    prefill,
    setPrefill,
    me,
    onSubmitInputs,
    slug,

    is_template,
}) {
    const [form] = Form.useForm();
    const [input_type, setInputType] = useState("ai_form");

    const applied_schema = schemas?.[input_data?.qureal_schema_id];

    log.d(user_inputs, "user_inputs in PresetInput");

    const user_input_fields = user_inputs?.user_input_fields || {};
    const prefilled_values = user_inputs?.extracted_user_inputs?.success
        ? user_inputs?.extracted_user_inputs?.data
        : {};
    const user_prompt = user_inputs?.user_prompt || "";

    log.d(prefilled_values, "prefilled_values in PresetInput");
    log.d(applied_schema, "applied_schema in PresetInput");

    // if (Object.keys(user_input_fields).length > 0) {
    //     return <UserInputFormOne
    //         fields={user_input_fields}
    //         prefilled_values={prefilled_values}
    //         onSubmit={(values) => {
    //             onAISubmit({
    //                 user_prompt: user_prompt,
    //                 user_filled_inputs: {
    //                     [data_block_id]: values
    //                 }
    //             })
    //         }}
    //         data_block_id={data_block_id}
    //     />
    // }

    return (
        <Fragment>
            <Segmented
                block
                options={[
                    {
                        label: "AI Form",
                        value: "ai_form",
                        // icon: <BulbOutlined />,
                        icon: getHeroIcon("sparkles", {
                            width: "14px",
                            marginBottom: "-2px",
                        }),
                    },
                    {
                        label: "Manual",
                        value: "manual_input",
                        icon: <EditOutlined />,
                    },
                    { label: "Bulk", value: "bulk", icon: <UploadOutlined /> },
                ]}
                value={input_type}
                onChange={setInputType}
                style={{ marginBottom: 12 }}
            />
            {input_type === "ai_form" && (
                <div className={styles.chat_box_wrapper}>
                    <PresetInputForm
                        schema={applied_schema}
                        onSubmit={onSubmitInputs}
                        isLoading={loadingAI}
                    />
                </div>
            )}
            {input_type === "manual_input" && (
                <div className={styles.chat_box_wrapper}>
                    <PresetHumanInput
                        data={{
                            schemas,
                            user_inputs,
                            input_data,
                            prefill,
                        }}
                        onChange={(new_values) => {
                            log.d(new_values, "new_values in TemplateAIInput");
                            setPrefill(new_values);
                        }}
                        me={me}
                        examples={applied_schema?.examples || []}
                    />
                </div>
            )}
            {input_type === "bulk" && (
                <div className={styles.chat_box_wrapper}>
                    <BulkGeneration
                        trigger={<Button>Open Bulk Generation</Button>}
                        slug={slug}
                        is_template={is_template}
                        schema={applied_schema}
                    />
                </div>
            )}

            <PresetTest
                examples={applied_schema?.examples || []}
                onSelect={(values) => {
                    setPrefill(values);
                }}
            />
        </Fragment>
    );
}

export function PresetInputForm({
    schema,
    isLoading,
    onSubmit,
    onChange,
    attachments = [],
}) {
    const [form] = Form.useForm();
    const [selected_products, setSelectedProducts] = useState({});
    const [img_values, setImgValues] = useState(() => {
        if (!attachments?.length || !schema?.inputs?.length) return {};
        const out = {};
        schema.inputs.forEach((input) => {
            if (input.type === "image") {
                out[input.key] = attachments[0];
            }
        });
        return out;
    });

    log.d(attachments, "attachments in QLC TAI");
    log.d(img_values, "img_values in QLC TAI");

    return (
        <div>
            {schema?.inputs?.length > 0 && (
                <Form
                    form={form}
                    layout="vertical"
                    // onFinish={onFinish}
                    onFinish={(values) => {
                        log.d(values, "values in PresetInputForm");
                        if (onSubmit) {
                            onSubmit({
                                ...values,
                                ...img_values,
                            });
                        }
                    }}
                    onValuesChange={(values, allValues) => {
                        log.d(values, "values in PresetInputForm");
                        log.d(allValues, "allValues in PresetInputForm");
                    }}
                    // onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    style={{
                        marginTop: "10px",
                    }}
                    {...(onChange
                        ? {
                              onValuesChange: onChange,
                          }
                        : {})}
                >
                    {schema?.inputs.map((input) => {
                        // Check if input type starts with "db" to create a RelationFieldStandard
                        const isDbType = input.type?.startsWith("db_");
                        const tableName = isDbType
                            ? input.type.substring(3)
                            : null; // Extract table name after "db_"

                        if (input.type === "image") {
                            return (
                                <Form.Item
                                    key={input.key}
                                    label={input.label || startCase(input.key)}
                                >
                                    <PhotoButton
                                        field={{
                                            collection: "qqq",
                                            field: input.key,
                                        }}
                                        value={img_values[input.key]?.id}
                                        width="150px"
                                        height="150px"
                                        objectFit="contain"
                                        show_placeholder={true}
                                        background="white"
                                        enable_remove_bg={false}
                                        onChangeFull={(photo_obj) => {
                                            setImgValues({
                                                ...img_values,
                                                [input.key]: photo_obj,
                                            });
                                        }}
                                    />
                                </Form.Item>
                            );
                        }

                        return (
                            <Form.Item
                                name={input.key}
                                label={input.label || startCase(input.key)}
                                rules={[
                                    // { required: true },
                                    { type: "string", max: 200 },
                                ]}
                            >
                                {(!input.type || input.type === "text") && (
                                    <Input placeholder="Enter mesage" />
                                )}
                                {input.type === "textarea" && (
                                    <TextArea
                                        rows={4}
                                        placeholder={
                                            input.label || "Enter mesage"
                                        }
                                    />
                                )}
                                {input.type === "db_qdb_product" && (
                                    <div>
                                        {selected_products[input.key] && (
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    padding: "6px 28px 6px 6px",
                                                    border: "1px solid #e0e0e0",
                                                    borderRadius: "8px",
                                                    background: "#fafafa",
                                                    maxWidth: "220px",
                                                    marginBottom: "8px",
                                                }}
                                            >
                                                <img
                                                    src={getPublicImageURL(
                                                        selected_products[
                                                            input.key
                                                        ].main_image,
                                                    )}
                                                    alt={
                                                        selected_products[
                                                            input.key
                                                        ].name
                                                    }
                                                    style={{
                                                        width: "44px",
                                                        height: "44px",
                                                        objectFit: "contain",
                                                        borderRadius: "4px",
                                                        border: "1px solid #f0f0f0",
                                                        flexShrink: 0,
                                                        background: "white",
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: "2px",
                                                        minWidth: 0,
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            fontSize: "0.8rem",
                                                            fontWeight: 600,
                                                            whiteSpace:
                                                                "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow:
                                                                "ellipsis",
                                                        }}
                                                    >
                                                        {
                                                            selected_products[
                                                                input.key
                                                            ].name
                                                        }
                                                    </span>
                                                    {selected_products[
                                                        input.key
                                                    ].price != null && (
                                                        <span
                                                            style={{
                                                                fontSize:
                                                                    "0.72rem",
                                                                color: "#52c41a",
                                                            }}
                                                        >
                                                            ₹
                                                            {
                                                                selected_products[
                                                                    input.key
                                                                ].price
                                                            }
                                                        </span>
                                                    )}
                                                </div>
                                                <CloseOutlined
                                                    style={{
                                                        position: "absolute",
                                                        top: "-4px",
                                                        right: "-4px",
                                                        backgroundColor:
                                                            "black",
                                                        color: "white",
                                                        borderRadius: "50%",
                                                        fontSize: "10px",
                                                        padding: "2px",
                                                        cursor: "pointer",
                                                        boxShadow:
                                                            "0 1px 3px rgba(0,0,0,0.2)",
                                                    }}
                                                    onClick={() => {
                                                        const nextImgs = {
                                                            ...img_values,
                                                        };
                                                        delete nextImgs[
                                                            input.key
                                                        ];
                                                        setImgValues(nextImgs);
                                                        const nextProds = {
                                                            ...selected_products,
                                                        };
                                                        delete nextProds[
                                                            input.key
                                                        ];
                                                        setSelectedProducts(
                                                            nextProds,
                                                        );
                                                    }}
                                                />
                                            </div>
                                        )}
                                        <ProductSelector
                                            trigger={
                                                <Button>
                                                    {selected_products[
                                                        input.key
                                                    ]
                                                        ? "Change Product"
                                                        : "Select Product"}
                                                </Button>
                                            }
                                            onSelect={(product) => {
                                                setImgValues({
                                                    ...img_values,
                                                    [input.key]: product.id,
                                                });
                                                setSelectedProducts({
                                                    ...selected_products,
                                                    [input.key]: product,
                                                });
                                            }}
                                        />
                                    </div>
                                )}
                                {isDbType &&
                                    tableName &&
                                    input.type !== "db_qdb_product" && (
                                        <RelationFieldStanard
                                            field={{
                                                foreign_key_table: tableName,
                                                template: "{{name}}",
                                                foreign_key_column: "id",
                                            }}
                                            onChange={(new_value) => {
                                                form.setFieldValue(
                                                    input.key,
                                                    new_value,
                                                );
                                            }}
                                            style={{
                                                width: "40%",
                                            }}
                                            showSearch={true}
                                            placeholder={
                                                input.label ||
                                                `Select ${startCase(tableName)}`
                                            }
                                        />
                                    )}
                            </Form.Item>
                        );
                    })}

                    {onSubmit && (
                        <Form.Item
                        // style={{ textAlign: "right" }}
                        >
                            <Space>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={isLoading}
                                    // icon={<BulbOutlined />}
                                    icon={getHeroIcon("sparkles", {
                                        width: "18px",
                                    })}
                                >
                                    Generate{" "}
                                    <TokenInButton count={COST_PROCESS_IDEA} />
                                </Button>
                                {/* <Button
                            htmlType="button"
                        >
                            Reset
                        </Button> */}
                                {/*  <LanguagePicker /> */}
                            </Space>
                        </Form.Item>
                    )}
                </Form>
            )}
        </div>
    );
}

export function DBInput({
    record_id,
    input_id,
    input_data,
    me,
    org,
    onOrgChange,
    onOrgChangeFull = () => {},
    person,
    onPersonChange,
    isMobile,
    prefill,

    setPrefill,
    preset,
}) {
    log.d(org, "org in DBInput");

    let form_field = null;
    if (input_id === "current_organization") {
        form_field = (
            <OrgPicker
                me={me}
                org={org}
                onOrgChange={onOrgChange}
                onOrgChangeFull={onOrgChangeFull}
                isMobile={isMobile}
                fields="id,name,is_personal,is_external,brand_colors"
            />
        );
    } else if (input_id === "current_person") {
        form_field = (
            <RelationFieldStanard
                field={{
                    foreign_key_table: "qdb_person",
                    template: "{{full_name}}",
                    foreign_key_column: "id",
                }}
                value={person}
                onChange={(new_person) => onPersonChange(new_person)}
                style={{
                    width: 200,
                    marginTop: "15px",
                }}
                showSearch={!isMobile}
            />
        );
    }
    return (
        <Form layout="vertical">
            <Form.Item name="organization" label="Organization">
                {/* {form_field} */}
                {/* <pre>{JSON.stringify(prefill, null, 2)}</pre> */}
                <div
                    style={{
                        display: "flex",
                        gap: "10px",
                    }}
                >
                    {form_field}
                    {input_data?.used_fields?.length > 0 && (
                        <CustomizeDBInput
                            input_id={input_id}
                            used_fields={input_data?.used_fields}
                            value={prefill?.exclude_fields}
                            onChange={(new_values) => {
                                const new_prefill = removeUsedFields(
                                    prefill,
                                    input_data?.used_fields,
                                );
                                setPrefill({
                                    ...new_prefill,
                                    exclude_fields: new_values,
                                    ...getBlankFilledValues(new_values),
                                });
                            }}
                        />
                    )}
                </div>
            </Form.Item>
            {preset === "no_preset" && (
                <Form.Item label="Add Preset" name="add_preset">
                    <PresetSelector
                        qpCreationId={preset}
                        record_id={record_id}
                    />
                </Form.Item>
            )}
            {/* <Form.Item label="Add Product" name="product">
                <RelationFieldStanard
                    field={{
                        foreign_key_table: "qdb_product",
                        template: "{{name}}",
                        foreign_key_column: "id",
                    }}
                    value={product}
                    onChange={}
                    style={{
                        width: 200,
                    }}
                    showSearch={!isMobile}
                />
            </Form.Item> */}
        </Form>
    );
}

export function getBlankFilledValues(fields) {
    // return Object.fromEntries(fields.map(field => [field, ""]))
    return Object.fromEntries(fields.map((field) => [field, "‎"]));
}

export function removeUsedFields(values, used_fields) {
    return Object.fromEntries(
        Object.entries(values || {}).filter(
            ([key]) => !used_fields.includes(key),
        ),
    );
}

export function CustomizeDBInput({ input_id, value, onChange, used_fields }) {
    const [open, setOpen] = useState(false);

    const value_reversed = used_fields?.filter(
        (item) => !value?.includes(item),
    );

    return (
        <Popover
            title="Show / Hide fields"
            trigger="click"
            placement="bottomRight"
            open={open}
            onOpenChange={setOpen}
            content={
                <div>
                    {used_fields?.length > 0 && (
                        <Checkbox.Group
                            style={{ width: "200px" }}
                            // value={value}
                            value={value_reversed}
                            // onChange={onChange}
                            onChange={(values) =>
                                onChange(
                                    used_fields?.filter(
                                        (item) => !values?.includes(item),
                                    ),
                                )
                            }
                        >
                            <Row>
                                {used_fields?.map((item) => {
                                    return (
                                        <Col
                                            key={item}
                                            // span={12}
                                            span={24}
                                        >
                                            <Checkbox value={item}>
                                                {startCase(item)}
                                            </Checkbox>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </Checkbox.Group>
                    )}
                </div>
            }
        >
            <Button icon={<ControlOutlined />}></Button>
        </Popover>
    );
}

function CustomizeDBInput_old_full({ input_data, value, onChange }) {
    const [open, setOpen] = useState(false);
    const { data, isSuccess } = useItemsFine(
        "qdb_field",
        `fields=id,name,table&filter={"table":{"_eq":"${input_data?.table}"}}`,
        open,
    );

    const table = input_data?.table;

    log.d(data, "Fields data");

    return (
        <Popover
            title="Show / Hide fields"
            trigger="click"
            placement="bottomRight"
            open={open}
            onOpenChange={setOpen}
            content={
                <div>
                    {isSuccess && (
                        <Checkbox.Group
                            style={{ width: "400px" }}
                            value={value}
                            onChange={onChange}
                        >
                            <Row>
                                {data?.map((item) => {
                                    return (
                                        <Col key={item.id} span={12}>
                                            <Checkbox value={item.id}>
                                                {startCase(item.name)}
                                            </Checkbox>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </Checkbox.Group>
                    )}
                </div>
            }
        >
            <Button icon={<ControlOutlined />}></Button>
        </Popover>
    );
}

function PresetTest({ examples, onSelect }) {
    if (examples?.length > 0) {
        return (
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    flexDirection: "row",
                    gap: "10px",
                    paddingTop: "10px",
                }}
            >
                {examples.map((exp, index) => {
                    const name = exp?.ex_label || `Test ${index}`;
                    return (
                        <div
                            onClick={() => {
                                onSelect(exp);
                            }}
                            style={{
                                padding: "5px 10px",
                                borderRadius: "5px",
                                border: "1px solid rgb(126, 126, 126)",
                                cursor: "pointer",
                            }}
                        >
                            {name}
                        </div>
                    );
                })}
            </div>
        );
    }
    return <></>;
}

function normalizeExtra(extra) {
    if (typeof extra !== "object") {
        return extra;
    }
    const out = {};
    Object.keys(extra).forEach((key) => {
        const val = extra[key];
        if ("maxChar" in val) {
            delete val.maxChar;
            out[key] = val;
        } else {
            out[key] = val;
        }
    });
    log.d(out, "normalized extra");
    return out;
}

function PresetSelector({ qpCreationId, record_id }) {
    const [open, setOpen] = useState(false);
    const { data, isLoading, isSuccess } = useItemsFine(
        "qdb_creation_schema",
        "fields=*&filter[is_blank][_eq]=true",
        open,
    );
    const mutation_update = useUpdateItemMutation();
    // () => {},
    // () => {},
    // () => {}
    console.log("data inside qdb creation ", data);
    console.log("qpcreationid", qpCreationId);
    const handleChange = (selectedId) => {
        try {
            const selectedItem = data?.find((item) => item.id === selectedId);
            if (!selectedItem) return;

            mutation_update.mutate({
                collection: "qp_creation",
                id: record_id,
                data: {
                    used_schemas: [
                        {
                            qdb_creation_schema_id: selectedId,
                        },
                    ],
                },
            });
            console.log("data mutated in presetselector");
            //      mutation_update.mutate({
            //     collection: "qdb_creation_schema",
            //     id: record.id,

            //     data: { enabled: !record.enabled },
            // });
        } catch (e) {
            log.e("failed to update used_schema in db", e);
        }
    };

    return (
        <Select
            loading={isLoading}
            onDropdownVisibleChange={setOpen}
            placeholder="Select a blank preset"
            style={{ width: "200px" }}
            onChange={handleChange}
        >
            {isSuccess &&
                data?.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                        {item.name}
                    </Select.Option>
                ))}
        </Select>
    );
}

export function LanguagePicker({ value, onChange }) {
    return (
        <Select
            showSearch
            placeholder="Select Language"
            value={value}
            onChange={onChange}
            options={[
                "English",
                "Hindi",
                "Marathi",
                "Tamil",
                "Telugu",
                "Kannada",
                "Malayalam",
                "Bengali",
            ].map((lang) => ({ label: lang, value: lang }))}
            style={{ width: 120 }}
        />
    );
}
